import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { ROUTE_KEYS, STORAGE_KEYS } from 'utils/constants';

const AuthRoute = ({ children }: { children: JSX.Element }) => {
  const token = localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN) || '';
  const isCompanyVerified = localStorage.getItem(STORAGE_KEYS.COMPANY_VERIFIED) === 'true';
  const { pathname } = useLocation();

  return !isCompanyVerified && pathname !== ROUTE_KEYS.VERIFICATION_PENDING ? (
    <Navigate to={ROUTE_KEYS.VERIFICATION_PENDING} />
  ) : token ? (
    children
  ) : (
    <Navigate to={`/${ROUTE_KEYS.AUTH}/${ROUTE_KEYS.LOGIN}`} />
  );
};
export default AuthRoute;
